"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default((theme) => ({
    root: {
        position: 'relative',
        padding: 0,
        verticalAlign: 'top',
        '& .MuiIconButton-label': {
            height: 22,
            width: 22,
        },
        '& svg': {
            fill: '#757575',
        },
    },
    checked: {
        '& svg': {
            fill: theme.palette.primary.dark,
        },
    },
    disabled: {
        backgroundColor: 'inherit',
    },
    highlightedIcon: {
        backgroundColor: theme.palette.editing,
    },
}));
//# sourceMappingURL=checkbox-styles.js.map